export const CountryCode = {
    FR: 'FR',
    BE: 'BE',
    CH: 'CH',
    LU: 'LU',
};
export const CoverageAreasResult = {
    DEPARTMENT: 'department',
    POSTAL_CODE: 'postal_code',
};
